const CSOSN = [
    {
        value: 101,
        label: "Tributada pelo Simples Nacional com permissão de crédito",
        description:
            "Classificam-se neste código as operações que permitem a indicação da alíquota do ICMS devido no Simples Nacional e o valor do crédito correspondente.",
    },
    {
        value: 102,
        label: "Tributada pelo Simples Nacional sem permissão de crédito",
        description:
            "Classificam-se neste código as operações que não permitem a indicação da alíquota do ICMS devido pelo Simples Nacional e do valor do crédito, e não estejam abrangidas nas hipóteses dos códigos 103, 203, 300, 400, 500 e 900.",
    },
    {
        value: 103,
        label: "Isenção do ICMS no Simples Nacional para faixa de receita bruta",
        description:
            "Classificam-se neste código as operações praticadas por optantes pelo Simples Nacional contemplados com isenção concedida para faixa de receita bruta nos termos da Lei Complementar Nº 123, de 2006.",
    },
    {
        value: 201,
        label:
            "Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária",
        description:
            "Classificam-se neste código as operações que permitem a indicação da alíquota do ICMS devido pelo Simples Nacional e do valor do crédito, e com cobrança do ICMS por substituição tributária.",
    },
    {
        value: 202,
        label:
            "Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária",
        description:
            "Classificam-se neste código as operações que não permitem a indicação da alíquota do ICMS devido pelo Simples Nacional e do valor do crédito, e não estejam abrangidas nas hipóteses dos códigos 103, 203, 300, 400, 500 e 900, e com cobrança do ICMS por substituição tributária.",
    },
    {
        value: 203,
        label:
            "Isenção do ICMS no Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária",
        description:
            "Classificam-se neste código as operações praticadas por optantes pelo Simples Nacional contemplados com isenção para faixa de receita bruta nos termos da Lei Complementar Nº 123, de 2006, e com cobrança do ICMS por substituição tributária.",
    },
    {
        value: 300,
        label: "Imune",
        description:
            "Classificam-se neste código as operações praticadas por optantes pelo Simples Nacional contempladas com imunidade do ICMS.",
    },
    {
        value: 400,
        label: "Não tributada pelo Simples Nacional",
        description:
            "Classificam-se neste código as operações praticadas por optantes pelo Simples Nacional não sujeitas à tributação pelo ICMS dentro do Simples Nacional.",
    },
    {
        value: 500,
        label:
            "ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação",
        description:
            "Classificam-se neste código as operações sujeitas exclusivamente ao regime de substituição tributária na condição de substituído tributário ou no caso de antecipações.",
    },
    {
        value: 900,
        label: "Outros",
        description:
            "Classificam-se neste código as demais operações que não se enquadrem nos códigos 101, 102, 103, 201, 202, 203, 300, 400 e 500.",
    },
];

export { CSOSN }


// WEBPACK FOOTER //
// ./src/components/pages/fiscal/taxes/template-icms/data.js